<template>
  <a-table
    :pagination="false"
    :columns="columns"
    :dataSource="dataSource"
    :rowSelection="{ selectedRowKeys, onSelectAll, onSelect }"

    @expandedRowsChange="keys => expandedRowKeys = keys"
    :expandedRowKeys="expandedRowKeys"
  >
    <span slot="customName" slot-scope="text, record">
      {{record.name}}
      <span v-if="record.children&&record.children.length">
        ({{record.selected || 0}}/{{record.children.length}})
      </span>
    </span>
  </a-table>
</template>
<script>
export default {
  name: 'SelectableTable',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    selectedRowKeys: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      expandedRowKeys: []
    }
  },
  computed: {},
  watch: {
    visible: function(visible) {
      if (!visible) this.expandedRowKeys = []
    }
  },
  methods: {
    onSelectAll(selected, selectedRows) {
      let selectedRowKeys = []
      if (selected) {
        const tabData = this.dataSource
        const arr = []
        setVal(tabData, arr)
        selectedRowKeys = arr
      }
      this.$emit('selectedChange', selectedRowKeys)

      function setVal(list, arr) {
        list.forEach(v => {
          arr.push(v.key)
          if (v.children) {
            setVal(v.children, arr)
          }
        })
      }
    },
    onSelect(record, selected, selectedRows) {
      const set = new Set(this.selectedRowKeys)
      const tabData = this.dataSource
      const key = record.key
      if (selected) {
        set.add(key)
        record.children && setChildCheck(record.children)
        setParentCheck(key)
      } else {
        set.delete(key)
        record.children && setChildUncheck(record.children)
        setParentUncheck(key)
      }

      this.$emit('selectedChange', Array.from(set))

      // 设置父级选择
      function setParentCheck(key) {
        let parent = getParent(key)
        if (parent) {
          set.add(parent.key)
          setParentCheck(parent.key)
        }
      }
      // 设置父级取消，如果父级的子集有选择，则不取消
      function setParentUncheck(key) {
        let childHasCheck = false,
          parent = getParent(key)
        if (parent) {
          let childlist = parent.children
          childlist.forEach(function(v) {
            if (set.has(v.key)) childHasCheck = true
          })
          if (!childHasCheck) {
            set.delete(parent.key)
            setParentUncheck(parent.key)
          }
        }
      }
      // 获取当前对象的父级
      function getParent(key) {
        for (let i = 0; i < tabData.length; i++) {
          if (tabData[i].key === key) {
            return null
          }
        }
        return _getParent(tabData)
        function _getParent(list) {
          let childlist,
            isExist = false
          for (let i = 0; i < list.length; i++) {
            if ((childlist = list[i].children)) {
              childlist.forEach(function(v) {
                if (v.key === key) isExist = true
              })
              if (isExist) {
                return list[i]
              }
              if (_getParent(childlist)) {
                return _getParent(childlist)
              }
            }
          }
        }
      }
      // 设置child全选
      function setChildCheck(list) {
        list.forEach(function(v) {
          set.add(v.key)
          v.children && setChildCheck(v.children)
        })
      }
      // 设置child取消
      function setChildUncheck(list) {
        list.forEach(function(v) {
          set.delete(v.key)
          v.children && setChildUncheck(v.children)
        })
      }
    }
  }
}
</script>

<style>
</style>
